<template>
    <div class="appointments-management">
        <form @submit.prevent="handleSubmit" method="post" class="d-flex justify-content-between w-100 align-items-end mt-5" style="gap: 3rem;">
            <div class="form-group m-0 w-100">
                <label>
                    {{ labelDuration }}
                </label>
                <input type="number" class="form-control" min="0" name="appointments_duration" v-model="appointmentsDuration" required>
            </div>
            <div class="form-group m-0 w-100">
                <label>
                    {{ labelPause }}
                </label>
                <input type="number" class="form-control" min="0" name="pauses_duration" v-model="pausesDuration" required>
            </div>
            <button type="submit" class="btn btn-blue flex-shrink-0">
                {{ buttonGenerate }}
            </button>
        </form>

        <div v-show="showConfirmationModal" class="modal-overlay">
            <div class="modal-container">
                <div class="modal-header">
                    <h4 class="p-0 m-0">
                        {{ modalTitle }}
                    </h4>
                </div>
                <div class="modal-body">
                    <p>
                        {{ modalDescription }}
                    </p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" @click="cancelGeneration">
                        {{ buttonCancel }}
                    </button>
                    <button type="button" class="btn btn-blue" @click="confirmGeneration">
                        {{ buttonConfirm }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    props: {
        lodge: {
            type: Object,
            required: true,
        },
        company: {
            type: Object,
            required: true,
        },
        labelDuration: String,
        labelPause: String,
        buttonGenerate: String,
        modalTitle: String,
        modalDescription: String,
        buttonCancel: String,
        buttonConfirm: String,
        errorMessage: String
    },
    data() {
        return {
            showConfirmationModal: false,
            appointmentsDuration: null,
            pausesDuration: null
        }
    },
    methods: {
        handleSubmit() {
            if (this.lodge.day_time_ranges && this.lodge.day_time_ranges.length) {
                this.showConfirmationModal = true;
            } else {
                this.submitForm();
            }
        },
        submitForm() {
            axios.post(`/company/${this.company.id}/lodges/${this.lodge.id}/generate-appointments`, {
                appointments_duration: this.appointmentsDuration,
                pauses_duration: this.pausesDuration
            })
            .then(response => {
                if (response.data.redirect) {
                    window.location.href = response.data.redirect;
                } else {
                    window.location.reload();
                }
            })
            .catch(error => {
                console.error(this.errorMessage, error);
            });
        },
        confirmGeneration() {
            this.showConfirmationModal = false;
            this.submitForm();
        },
        cancelGeneration() {
            this.showConfirmationModal = false;
        }
    }
}
</script>
